import { graphql } from "../generated";

export const GenerateAIAnswers = graphql(`
  mutation GenerateAIAnswers($input: GenerateAIAnswersInput!) {
    generateAIAnswers(input: $input)
  }
`);
